import React, {useState, useEffect} from 'react';
import { Http } from '../utils/http';
import { Navigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Layout from './Layout';

import { ClientState } from '../context/AppContext';
import { PageRoute } from '../models/PageRoute';

import DOMPurify from 'dompurify';


declare const AppConfig: any;

const sanitize = (content) => {
  return DOMPurify.sanitize(content, {
      ADD_ATTR: ['target', 'alt']
  });
};


export const PageSnippet: React.FC<any> = (props: any) => {
  const [content, setContent] = useState('');
  const [followLink, setFollowLink] = useState('');

  useEffect(() => {
    if (props.slug) {
      if (props.forceLoad) {
        ClientState.refreshNonce();
      }

      Http.get().getPageContent(props.slug, ClientState.nonce)
          .then((content: string) => {
            setContent(content);
            if (props.successCallback) {
              props.successCallback();
            }
          })
          .catch((error: any) => {
            if (props.notFoundCallback) {
              props.notFoundCallback();
            }
          });
    }
  },
  [props.slug]);

  useEffect(() => {
    document.querySelectorAll('.qsa-snippet-text a').forEach((link: Element) => {
      const a = link as HTMLAnchorElement;

      if (!a.getAttribute('data-rr-link')) {
        const href = a.getAttribute('href') || '';

        if (href.startsWith("/pages") &&
          a.target !== '_blank') {
          a.addEventListener('click', (e) => {
            e.preventDefault();
            setFollowLink(href);
          });
        }
        a.setAttribute('data-rr-link', 'true');
      }
    });
  });

  if (followLink) {
    return <Navigate to={followLink} replace={false} />;
  } else {
    return <div className="qsa-snippet-text" dangerouslySetInnerHTML={{__html: sanitize(props.content || content)}} />
  }
}

const PageViewPage: React.FC<PageRoute> = (route: PageRoute) => {
  const [notFound, setNotFound] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const firstChild = document.querySelector('.page-content h1');

    if (firstChild) {
      route.setPageTitle((firstChild as HTMLElement).innerText || '');
    }
  }, [loaded, route]);

  if (notFound) {
    return <Navigate to="/404" replace={false} />;
  }

  const params = useParams();

  return (
    <Layout>
      <div className="page-content">
        <PageSnippet
          forceLoad={true}
          slug={params.slug}
          successCallback={() => setLoaded(true)}
          notFoundCallback={() => setNotFound(true)}
        />
      </div>
    </Layout>
  );
};

export default PageViewPage;
